module.exports = {
	"actionUrl": "https://docs.google.com/forms/d/e/1FAIpQLSc7y55LztpGqvKk37Q4JvJRs0GyDxvCtq_JUqTp9-edau_b4g/formResponse",
	"fields": {
		"Player": "entry.1071415515"
	}
};


//////////////////
// WEBPACK FOOTER
// ./formDetails/bets.json
// module id = 25
// module chunks = 0